import { render, staticRenderFns } from "./OutsideScene.vue?vue&type=template&id=4a26aed7"
import script from "./OutsideScene.vue?vue&type=script&lang=js"
export * from "./OutsideScene.vue?vue&type=script&lang=js"
import style0 from "./OutsideScene.vue?vue&type=style&index=0&id=4a26aed7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports